import React from 'react';
import styled, { css } from 'styled-components';
import {
  minBreakpointQuery,
  brandColours,
  fontSize,
  visuallyHidden,
  standardColours,
  fontWeights,
} from '../styles';
import { Link } from './ui';
import { buildUrl } from '../utils';

const StyledPagination = styled.nav`
  padding: 30px 0;

  ${minBreakpointQuery.small`
    padding-top: 40px;
    padding-bottom: 40px;
  `}

  ${minBreakpointQuery.large`
    padding-top: 50px;
    padding-bottom: 50px;
  `}

  ${minBreakpointQuery.xxlarge`
    padding-top: 60px;
    padding-bottom: 60px;
  `}
`;

const StyledItems = styled.ol`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const StyledItem = styled.li`
  margin: 5px;
`;

const commonLinkStyles = () => {
  return css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
    height: 40px;
    width: 40px;
    ${fontSize(18)};
    font-weight: ${fontWeights.bold};
    background-color: ${standardColours.white};
    border: solid 1px ${brandColours.secondary};
    border-radius: 50%;

    ${minBreakpointQuery.small`
      height: 50px;
      width: 50px;
    `}

    ${minBreakpointQuery.large`
      height: 60px;
      width: 60px;
    `}

    &.pagination-active {
      color: ${standardColours.white};
      background-color: ${brandColours.secondary};
    }

    span {
      ${visuallyHidden()};
    }
  `;
};

const StyledLink = styled(Link)`
  ${commonLinkStyles()};
`;

const Pagination = ({ totalPageCount, listingPage, currentPageCount }) =>
  totalPageCount > 0 && (
    <StyledPagination>
      <StyledItems>
        {[...Array(totalPageCount)].map((item, i) => {
          const pageCount = i + 1;

          return (
            <StyledItem>
              <StyledLink
                to={`${buildUrl(listingPage.slug, listingPage)}${
                  pageCount > 1 ? `page/${pageCount}` : ''
                }`}
                className={
                  pageCount === currentPageCount && 'pagination-active'
                }
              >
                {pageCount}
              </StyledLink>
            </StyledItem>
          );
        })}
      </StyledItems>
    </StyledPagination>
  );

export default Pagination;
